import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import ReactSelect from "../../UI/ReactSelect";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import Preview from "../components/Preview.js";
import PlusIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import * as Yup from "yup";
import InputMask from "react-input-mask";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },

  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 20,
  },
}));

export default function Edit(props) {
  const classes = useStyles();

  const {
    onHide,
    show,
    partner,
    onPartners,
    skip,
    take,
    sortField,
    orderBy,
    citiesAll,
  } = props;
  const {
    id,
    name,
    contactPerson,
    phoneNumber,
    email,
    filePath,
    cities,
  } = partner;


  const fileUrl = "https://cdn.deyerlisen.az/" + filePath;
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState(true);
  const [imageSrc, setImageSrc] = useState(fileUrl);
  useEffect(() => {
    setImageSrc(fileUrl);
  }, [fileUrl]);

  const _defaultCosts = [
    {
      id:"",
      cityId: "",
      address: "",
      latitude: "",
      longitude: "",
    },
  ];

  const [isError, setIsError] = useState("");
  const [costs, setCosts] = useState(_defaultCosts);
  const [deleteItem, setDeleteItem] = useState([]);

  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };

  const [citiesOptions, setCitiesOptions] = useState([]);
  const [citiesOption, setCitiesOption] = React.useState([{}]);

  function handleChangeCities(value, name, index, setFieldValue) {
    let newCities = [...citiesOption];
    newCities[index] = value;
    setCitiesOption(newCities);
    setFieldValue(name, value.value);
  }

  useEffect(() => {
    setCitiesOptions(
      citiesAll.map((suggestion) => ({
        value: suggestion.id,
        label: suggestion.name,
      }))
    );
  }, [citiesAll]);

  useEffect(() => {
    if (cities !== undefined) {
      setCosts(cities);
      const newOption = [];
      cities.forEach(({ cityId }) => {
        newOption.push(citiesOptions.find(({ value }) => value === cityId));
      });

      setCitiesOption(newOption);
    }
  }, [cities, citiesOptions]);

  useEffect(() => {
    if (!show) {
      setCitiesOption(null);
    }
  }, [show]);

  const form = useRef(null);
  const onPutPartner = (values, resetForm, setSubmitting) => {
    const partner = new FormData(form.current);
    // Object.keys(values).map((key, index) => {
    //   if (key === "cityId") {
    //     values[key].map((value) => partner.append(`${key}`, value));
    //   } else {
    //     partner.append(key, values[key]);
    //   }
    //   return index
    // });

    deleteItem.forEach((itemId, index) => {
      partner.append(`deletedCities[${index}]`, itemId);
    });
  
    costs.forEach((value, index) => {
      if (value?.id) {
        partner.append(`Cities[${index}].Id`, value.id);
      }else{
        partner.append(`Cities[${index}].Id`, 0);
      }
      if (value?.cityId) {
        partner.append(`Cities[${index}].CityId`, value.cityId);
      }
      if (value?.address?.trim()) {
        partner.append(`Cities[${index}].Address`, value.address);
      }
      if (value?.latitude?.trim()) {
        partner.append(`Cities[${index}].Latitude`, value.latitude);
      }
      if (value?.longitude?.trim()) {
        partner.append(`Cities[${index}].Longitude`, value.longitude);
      }
    });

    axios
      .put(`${process.env.REACT_APP_API_URL}partner`, partner, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then(() => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onPartners(skip, take, sortField, orderBy);
        setPreview(true);
        setImageSrc("");
        setFile("");
        setDeleteItem([])
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const EditSchema = Yup.object().shape({
    // address: Yup.string().required("Address is required"),
    // latitude: Yup.string().required("Latitude is required"),
    // longitude: Yup.string().required("Longitude is required"),
  });

  const getInputClasses = (touched, errors, fieldName) => {
    if (touched[fieldName] && errors[fieldName]) {
      return true;
    }
    if (touched[fieldName] && errors[fieldName]) {
      return false;
    }

    return false;
  };

  useEffect(() => {
    if (!show) {
      setCitiesOption([]);
    }
  }, [show]);

  const handleCostsChange = (event) => {
    const _tempCosts = [...costs];
    _tempCosts[event.target.dataset.id][event.target.name] = event.target.value;
    setCosts(_tempCosts);
  };
  const handleCostsChangeName = (fieldName, index, value) => {
    const _tempCosts = [...costs];
    _tempCosts[index][fieldName] = value;
    setCosts(_tempCosts);
  };

  const addNewCost = () => {
    setCosts((prevCosts) => [
      ...prevCosts,
      { cityId: "", address: "", latitude: "", longitude: "" },
    ]);
  };

  const removeCost = (index, itemId) => {
    const _tempCosts = [...costs];
    setCosts(_tempCosts.filter((v, i) => i !== index));
    itemId && setDeleteItem((prevItem) => [...prevItem, itemId]);
  };

  return (
    <Modal
      size="md"
      onHide={onHide}
      show={show}
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      {partner &&
        Object.keys(partner).length !== 0 &&
        partner.constructor === Object && (
          <Formik
            initialValues={{
              id: id,
              name: name,
              contactPersonFirstName: contactPerson?.trim().split(" ")[0],
              contactPersonLastName: contactPerson?.trim().split(" ")[1],
              phoneNumber: phoneNumber,
              email: email,
              filePath: filePath,
              cityId: cities,
              
            }}
            validationSchema={EditSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
              onPutPartner(values, resetForm, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              handleChange,
              handleBlur,
              resetForm,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit} ref={form}>
                <Modal.Header closeButton>
                  <Modal.Title id="edit">Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-12 pl-4 pr-4">
                    <div className="row">
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {isError && (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block MuiFormLabel-root Mui-error">
                                {isError}
                              </div>
                            </div>
                          )}
                          <input
                            type="hidden"
                            id="id"
                            name="id"
                            value={values.id}
                          />
                          <TextField
                            id="name"
                            name="name"
                            label="Name"
                            placeholder="Name"
                            className="w-100"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="contactPersonFirstName"
                            name="contactPersonFirstName"
                            label="Contact person first name"
                            placeholder="Contact person first name"
                            className="w-100"
                            value={values.contactPersonFirstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="contactPersonLastName"
                            name="contactPersonLastName"
                            label="Contact person last name"
                            placeholder="Contact person last name"
                            className="w-100"
                            value={values.contactPersonLastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {/* <TextField
                            id="phoneNumber"
                            name="phoneNumber"
                            label="Phone number"
                            placeholder="Phone number"
                            className="w-100"
                            value={values.phoneNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          /> */}
                          <InputMask
                            mask="\9\94999999999"
                            value={values.phoneNumber}
                            // onChange={(e) => handleChangePhoneNumber(e)}
                            onChange={handleChange}
                            disabled={false}
                            maskChar=""
                            id="phoneNumber"
                            type="number"
                          >
                            {() => (
                              <TextField
                                label="Phone number"
                                placeholder="Phone number"
                                className="w-100"
                                name="phoneNumber"
                                // onKeyDown={handleEnter}

                                // error={getInputClasses("phone")}
                                // {...formik.getFieldProps("phone")}
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="email"
                            name="email"
                            label="Email"
                            placeholder="Email"
                            className="w-100"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>

                      {costs.map((item, index) => (
                        <div className="col-12 col-md-12 col-lg-12" key={index}>
                          <div>
                            {index ? (
                              <div className="d-flex justify-content-end">
                                <Button
                                  variant="light"
                                  className={classes.button}
                                  onClick={() => removeCost(index, item.id)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                              <input
                                type="text"
                                hidden
                                name={`${
                                  index === 0 ? "cityId" : `cityId[${index}]`
                                }`}
                                data-id={index}
                              />
                              <ReactSelect
                                suggestions={citiesOptions}
                                handleChangeSingle={(value) => {
                                  handleChangeCities(
                                    value,
                                    `${
                                      index === 0
                                        ? "cityId"
                                        : `cityId[${index}]`
                                    }`,
                                    index,
                                    setFieldValue
                                  );
                                  handleCostsChangeName(
                                    "cityId",
                                    index,
                                    value.value
                                  );
                                }}
                                single={citiesOption[index]}
                                label="Choose cities"
                                placeholder="Choose cities"
                                error={getInputClasses(
                                  `${
                                    index === 0 ? "cityId" : `cityId[${index}]`
                                  }`
                                )}
                              />
                            </div>
                          </div>
                          <div>
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                              <TextField
                                id="address"
                                name="address"
                                label="Address"
                                placeholder="Address"
                                className="w-100"
                                error={getInputClasses("address")}
                                // {...formik.getFieldProps("address")}
                                onChange={handleCostsChange}
                                inputProps={{
                                  "data-id": index,
                                }}
                                value={item.address}
                              />
                            </div>
                          </div>
                          <div>
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                              <TextField
                                id="latitude"
                                name="latitude"
                                label="Latitude"
                                placeholder="Latitude"
                                className="w-100"
                                onChange={handleCostsChange}
                                inputProps={{
                                  "data-id": index,
                                }}
                                value={item.latitude}
                                error={getInputClasses("latitude")}
                              />
                            </div>
                          </div>
                          <div>
                            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                              <TextField
                                id="longitude"
                                name="longitude"
                                label="Longitude"
                                placeholder="Longitude"
                                className="w-100"
                                onChange={handleCostsChange}
                                inputProps={{
                                  "data-id": index,
                                }}
                                value={item.longitude}
                                error={getInputClasses("longitude")}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                      <Button
                        variant="light"
                        className={classes.button}
                        onClick={addNewCost}
                      >
                        Add new city
                        <PlusIcon className={classes.rightIcon} />
                      </Button>

                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3">
                          <label htmlFor="contained-button-file">
                            <Input
                              accept="image/*"
                              id="contained-button-file"
                              type="file"
                              name="file"
                              label="File URL"
                              placeholder="File URL"
                              className="w-100"
                              onChange={imagePreview}
                              value={file}
                              hidden
                            />
                            <Button2 variant="contained" component="span">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Devices/Camera.svg"
                                )}
                                className="mr-2"
                              />
                              Change image
                            </Button2>
                          </label>
                          <Preview
                            preview={preview}
                            imageSrc={imageSrc}
                            onClick={onClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="light"
                    onClick={() => {
                      onHide(false);
                      resetForm();
                    }}
                  >
                    Close
                  </Button>
                  <Button type="submit">Save</Button>
                </Modal.Footer>
              </form>
            )}
          </Formik>
        )}
    </Modal>
  );
}
